export default __webpack_public_path__ + "static/media/your-employees-will-quit.578a81f2.md";